module.exports = __webpack_public_path__ + "files/8aa43f3d86f2b882e53a69b42c08a8d6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/themes/code_themes/monokai.png
 ** module id = 821
 ** module chunks = 0
 **/